import { createContext, useState } from "react";
import Cookies from "js-cookie";
import axios from "axios";

const userContext = createContext();

const ProviderAuth = ({ children }) => {
  const [user, setUser] = useState(null);

  const googleSuccess = (profile) => {
    const email = profile.email;
    const name = profile.name;
    const given_name = profile.given_name;
    const family_name = profile.family_name;
    const googleId = profile.sub;
    const result = { email, family_name, name, given_name, googleId };
    Cookies.set("user", JSON.stringify(result));
    setUser(result);
    return result;
  };

  const onSuccess = (codeResponse) => {
    const access_token = codeResponse.access_token
    const profile = getUser(access_token);
    localStorage.setItem("idToken", access_token);

    return profile;
  };
  const onFailure = (res) => {
    setUser(null);
  };

  const getUser = async (token) => {
    const profile = await axios.get(
      `https://www.googleapis.com/oauth2/v3/userinfo?access_token=${token}`
    )
    const parseUser = googleSuccess(profile.data);
    return parseUser;
  };

  return (
    <userContext.Provider value={{ onSuccess, onFailure, user }}>
      {children}
    </userContext.Provider>
  );
};

export { ProviderAuth };
export default userContext;
